import { IWorkspaceContext, IUsersOrganization } from 'wisestep-base';

import axios from '../../../axios';
import ISaveWorkspacePaidButNotOnboardedParam from '../types/ISaveWorkspacePaidButNotOnboardedParam';
import ISaveWorkspaceParam from '../types/ISaveWorkspaceParam';
import IValidateLinkParam from '../types/IValidateLinkParam';
import IWorkspaceInviteParam from '../types/IWorkspaceInviteParam';
import IWorkspacePaymentInfo from '../types/IWorkspacePaymentInfo';
import IWorkspaceUserFilter from '../types/IWorkspaceUserFilter';

export const saveWorkspace = (data: ISaveWorkspaceParam) => axios.post('/api/workspace/', data);
export const updateWorkspace = (data: IWorkspaceContext) => axios.put('/api/workspace/', data);
export const updateUsersCompany = (data: IUsersOrganization) =>
  axios.put('/recruitersearch/api/fresh-sales/company', data);
export const workspaceValidateLink = (data: IValidateLinkParam) =>
  axios.put('/api/workspace/validate-link', data);
export const getCurrentWorkspaceUser = () => axios.get('api/workspace/current_user');
export const acceptWorkspaceInvite = (param: IWorkspaceInviteParam) =>
  axios.put('api/workspace/accept-invitation', param);
export const getSelectedWorkspace = () => axios.get('api/workspace/get-role-by-user-workspace');
export const getCurrentWorkspace = () => axios.get(`/api/workspace/current_workspace`);
export const getMaxUsersInWorkspace = (featureCodes: string[]) =>
  axios.get(`/api/plan/feature/balance/usage?featureCodes=${featureCodes}`);
export const getCurrentWorkspaceEntity = () => axios.get('api/workspace/current_workspace_entity');
export const postError = (error: any) => axios.post('api/logs', error);
export const getWorkspace = (query: string) =>
  axios.get(
    `/recruitersearch/api/workspace/search?page=0&query=${query}&size=50&sort=createdOn,desc`
  );

export const getWorkspaceById = (query: string) => axios.get(`/api/workspace/${query}/load`);

export const getAllNonExpiredSKUList = (workspaceId: string) =>
  axios.get(`api/workspaceplan/sku/${workspaceId}`);

export const getCurrentWorkspaceSKU = (workspaceId: string) =>
  axios.get(`api/workspaceplan/current-sku/${workspaceId}`);

export const getPlanTypeCountMetrics = () =>
  axios.get('recruitersearch/api/workspace/plan/metrics');

export const getPremiumWorkspaceMetrics = () =>
  axios.get(`recruitersearch/api/workspace/plan/premium-plan-metrics`);

export const getExpiredWorkspaceMetrics = () =>
  axios.get(`recruitersearch/api/workspace/plan/expired-plan-metrics`);

export const getWorkspaceActivityMetrics = () =>
  axios.get(`recruitersearch/api/workspace/plan/workspace-activity-metrics`);

export const getWorkspaceExpiringInMonthMetrics = () =>
  axios.get(`recruitersearch/api/workspace/plan/workspace-expiry-metrics`);

export const getNewWorkspaceAddedMetrics = () =>
  axios.get(`recruitersearch/api/workspace/plan/workspace-added-metrics`);

export const getNewUsersAddedMetrics = () =>
  axios.get(`recruitersearch/api/workspace/plan/users-added-metrics`);

export const saveWorkspacePaidButNotOnboarded = (data: ISaveWorkspacePaidButNotOnboardedParam) =>
  axios.post('recruitersearch/api/paid-user-details/save', data);

export const getWorkspacePaidButNotOnboarded = (payload: ISaveWorkspacePaidButNotOnboardedParam) =>
  axios.post('recruitersearch/api/paid-user-details/get', payload);

export const captureWorkspacePaymentInfo = (payload: IWorkspacePaymentInfo) =>
  axios.post(`/api/workspace/payment/info`, payload);

export const getWorkspacePaymentInfo = () => axios.get(`/api/workspace/payment/info`);

export const generateWorkSpaceAPIKeys = (workSpaceId: string) =>
  axios.post(`/api/generate-api-keys/${workSpaceId}`, {});

export const getWorkSpaceApiKeys = (workSpaceId: string) =>
  axios.get(`/api/api-keys/list/${workSpaceId}`);

export const getSecretKeyDetails = (apiKey: string) =>
  axios.get(`/api/api-secret-details/${apiKey}`);

export const getWorkspacesList = () => axios.get(`api/workspace/get-all-workspaces`);

export const getUserCountsInWorkspace = () =>
  axios.get(`recruitersearch/api/workspace/user-counts`);

export const getWorkspaceUsers = (filter: IWorkspaceUserFilter) =>
  axios.post(`api/workspace-users`, filter);

export const getWorkspaceUsersWithoutPagination = (filter: IWorkspaceUserFilter) =>
  axios.post(`recruitersearch/api/workspace-users-no-pagination`, filter);

export const getWorkspaceUserById = (userId: string) =>
  axios.get('api/workspace/get-role-by-user-workspace', { params: { userId } });

export const getBusinessUnitsByUserId = () => axios.get('api/workspace/users/businessunits/');

export const triggerUsersImport = () => axios.post('api/workspace/users/moving-data-to-postgres');

export const assignUsersToWorkspaceUser = (filter: IWorkspaceUserFilter) =>
  axios.put(`/api/user-access/assign`, filter);

export const unAssignUsersToWorkspaceUser = (filter: IWorkspaceUserFilter) =>
  axios.put(`/api/user-access/unassign`, filter);
